// extracted by mini-css-extract-plugin
module.exports = {"quote":"quote-module--quote--2-oW3","quote__char":"quote-module--quote__char--y3r8R"};